import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { Table } from 'reactstrap';
import PageLoader from '../../Common/PageLoader';
import { OBTENER_DETALLE_PROCESO_FACTOR_INTEGRACION } from '../../../graphql/queries/factorIntegracion';

const factor = (valor) => Number(valor).toFixed(4);
const importe = (valor) => '$' + Number(valor).toFixed(2);

// Empleados que cambiaron (o fallaron) en un proceso de actualización, con el factor de integración
// y el SDI que tenían antes y los que quedaron. Solo aparecen los que cambiaron: los que ya estaban
// al día no generan detalle.
const Detalle = ({ procesoId }) => (
  <Query
    query={OBTENER_DETALLE_PROCESO_FACTOR_INTEGRACION}
    variables={{ procesoId }}
    fetchPolicy='network-only'
  >
    {({ loading, error, data }) => {
      if (loading) {
        return <PageLoader />;
      }

      if (error) {
        const detalle = error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].message;
        return <div className='text-danger p-3'>{detalle || error.message}</div>;
      }

      const empleados =
        (data && data.factorIntegracion && data.factorIntegracion.detalle) || [];

      if (empleados.length === 0) {
        return (
          <div className='p-3'>
            No hay empleados que mostrar: o todos tenían ya su factor de integración al día, o los que cambiaron no
            son de tus grupos de nómina.
          </div>
        );
      }

      return (
        <Table responsive hover size='sm'>
          <thead>
            <tr>
              <th>Clave</th>
              <th>Empleado</th>
              <th>Cliente</th>
              <th>Grupo de nómina</th>
              <th>Sucursal</th>
              <th className='text-right'>FI anterior</th>
              <th className='text-right'>FI nuevo</th>
              <th className='text-right'>SDI anterior</th>
              <th className='text-right'>SDI nuevo</th>
              <th>Observaciones</th>
            </tr>
          </thead>
          <tbody>
            {empleados.map((empleado) => (
              <tr key={empleado.id} className={empleado.error ? 'text-danger' : ''}>
                <td>{empleado.claveEmpleado}</td>
                <td>{empleado.nombreCompleto}</td>
                <td>{empleado.nombreCliente}</td>
                <td>{empleado.nombreGrupo}</td>
                <td>{empleado.nombreSucursal}</td>
                <td className='text-right'>{factor(empleado.factorAnterior)}</td>
                <td className='text-right'>{empleado.error ? '—' : factor(empleado.factorNuevo)}</td>
                <td className='text-right'>{importe(empleado.sdiAnterior)}</td>
                <td className='text-right'>{empleado.error ? '—' : importe(empleado.sdiNuevo)}</td>
                <td>{empleado.error || ''}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    }}
  </Query>
);

Detalle.propTypes = {
  procesoId: PropTypes.string.isRequired
};

export default Detalle;
